require('./cardModifyLimitView.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
// @ commons
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
// @ constants
const { FIRST_STEP } = require('constants/index');
// @ actions
const cardModifyLimitActions = require('actions/cardModifyLimit');
// @ components
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { ModifyLimitStep1 } = require('components/cards/cardModifyLimitSteps/modifyLimitStep1/modifyLimitStep1');
const ModifyLimitStep2 = require('components/cards/cardModifyLimitSteps/modifyLimitStep2/modifyLimitStep2');
const ModifyLimitSuccessStep = require('components/cards/cardModifyLimitSteps/modifyLimitSuccessStep/modifyLimitSuccessStep');
const ModifyLimitErrorStep = require('components/cards/cardModifyLimitSteps/modifyLimitErrorStep/modifyLimitErrorStep');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
const { LoadingSection } = require('commonsComponents/loadingSection');
const CardHeaderDetails = require('components/cards/cardHeaderDetails/cardHeaderDetails');
// @ utilities
const { cardConstants } = require('utilities/accessHelperConditions/cards');
const AccessHelper = require('utilities/accessHelper');
const { PAGE_GENERIC, recordPath } = require('utilities/tagging');
// @ constants
const { GRAPHIC_TUTOR_TYPE_4 } = require('constants/index');
const {
    CREDIT_CARD_REVOLVING_PROCESS,
} = require('constants/flagBasedFeatures');

class CardModifyLimitView extends React.Component {
    constructor(props) {
        super(props);

        this.handleCancel = this.handleCancel.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
    }

    componentDidMount() {
        const { history, immCards, match: { params: { cardId } } } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);

        AccessHelper.allowAccess(cardConstants.CARD_MODIFY_LIMIT, { immCard }, history);

        this.props.requestLimits(cardId);
        const { setUpStep } = this.props;
        setUpStep(immCard.get('limit'));

        const tagging = immCard.get('tagging');
        recordPath('tarjeta/cambio-limite', PAGE_GENERIC, '', '', tagging);
    }

    componentWillUnmount() {
        this.props.clearRequest();
    }

    buildHeader(immCard) {
        const type = immCard.get('type');
        const subtitleLeft = formatText(`cards-${type}`);
        const subtitleRight = immCard.get('alias').get('current');
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-cards'),
                url: '/myprofile/cards'
            },
            {
                text: immCard.get('alias').get('current'),
                url: `/myprofile/cards/${this.props.match.params.cardId}/movements`
            },
            {
                text: formatText('cardDetails-limitLink')
            }
        ];
        const tutorial = (
            <TutorialLauncher
                type={GRAPHIC_TUTOR_TYPE_4}
                title={formatText('tutorials-cardsModifyLimitTitle')}
            />
        );
        return (
            <OKCover size="medium" section="cards" customClass="col-xs-12">
                <OKHeaderSubPage
                    breadcrumbConfig={mappingBreadcrumb}
                    subtitleLeft={subtitleLeft}
                    subtitleRight={subtitleRight}
                    tutorial={tutorial}
                    finalTitle={getFinalTitle('cardModifyLimit-modifyCreditLimit')}>
                    <CardHeaderDetails immCard={immCard} />
                </OKHeaderSubPage>
            </OKCover>
        );
    }


    buildFailure(immCard, immCardModifyLimit) {
        const { redirect, buttonText } = this.props

        return (
            <ModifyLimitErrorStep
                url={redirect}
                buttonText={buttonText}
                immCard={immCard}
                immCardModifyLimit={immCardModifyLimit}
            />
        );
    }

    buildSuccess(immCard, immCardModifyLimit) {
        const { redirect, buttonText } = this.props

        return (
            <ModifyLimitSuccessStep
                url={redirect}
                buttonText={buttonText}
                immCard={immCard}
                immCardModifyLimit={immCardModifyLimit}
            />
        );
    }

    buildWizard(immCard) {
        const {
            immCardModifyLimit,
            immFlagBasedFeatures,
            immProfile,
            validateStep,
            setVisibleStep,
            setWillCancel,
            handleAgreementCheckboxChange,
            handleLimitChange,
            handleCloseModal,
            handleModalContinueButtonClick,
            immRevolvingPersistentData,
            setUpStep
        } = this.props;

        const immSteps = immCardModifyLimit.get('steps');
        const immStepOne = immSteps.get(FIRST_STEP);
        const isLimitInvalid = immStepOne.get('isLimitInvalid');
        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            finish: this.handleFinish,
            cancel: this.handleCancel
        };
        const showIneAndRevolving = immFlagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
        const nextButtonDisabled = immRevolvingPersistentData.get('isIframeIsFetching') || immRevolvingPersistentData.get('isIframeError');

        const wizard = (
            <Wizard
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={immCardModifyLimit.get('visibleStep')}
                showPreLeaveModal={!immProfile.get('isNerudaUser')}
            >
                <WizardStep
                    cancelButton={true}
                    nextButtonDisabled={nextButtonDisabled}
                    position="first"
                >
                    <ModifyLimitStep1
                        immCard={immCard}
                        immCardModifyLimit={immCardModifyLimit}
                        handleLimitChange={handleLimitChange}
                        handleCloseModal={handleCloseModal}
                        handleModalContinueButtonClick={handleModalContinueButtonClick}
                        setUpStep={setUpStep}
                        isLimitInvalid={isLimitInvalid}
                        showIneAndRevolving={showIneAndRevolving}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    cancelButton={true}
                    addLoadingBehaviour={true}
                    immFinalButton="common-confirm"
                    isLoading={immCardModifyLimit.get('isFetching')}
                >
                    <ModifyLimitStep2
                        handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                        immCard={immCard}
                        contractName={immCard.get('contractName')}
                        immStepOne={immStepOne}
                        immCardModifyLimit={immCardModifyLimit}
                        showIneAndRevolving={showIneAndRevolving}
                    />
                </WizardStep>
            </Wizard>
        );

        return (
            <div className="col-xs-12">
                {wizard}
            </div>
        );
    }

    handleCancel() {
        const { redirect, history } = this.props

        history.push(redirect);
    }

    handleFinish() {
        const { cardId } = this.props.match.params;
        this.props.modifyLimit(cardId);
    }

    render() {
        const { match: { params: { cardId } }, immCards, immCardModifyLimit } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);
        let header;
        let bodyContent = <LoadingSection />;

        if (immCard) {
            header = this.buildHeader(immCard);

            if (immCardModifyLimit.get('error')) {
                bodyContent = this.buildFailure(immCard, immCardModifyLimit);
            } else if (immCardModifyLimit.get('success')) {
                bodyContent = this.buildSuccess(immCard, immCardModifyLimit);
            } else {
                bodyContent = this.buildWizard(immCard);
            }
        }

        return (
            <div>
                <div className="container-fluid card-movements--header-identifier">
                    <div className="row">
                        {header}
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            {bodyContent}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

CardModifyLimitView.propTypes = {
    history: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immCardModifyLimit: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immRevolvingPersistentData: PropTypes.object,
    requestLimits: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    clearRequest: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    handleAgreementCheckboxChange: PropTypes.func,
    handleLimitChange: PropTypes.func,
    handleCloseModal: PropTypes.func.isRequired,
    handleModalContinueButtonClick: PropTypes.func.isRequired,
    modifyLimit: PropTypes.func.isRequired,
    setUpStep: PropTypes.func.isRequired,
    redirect: PropTypes.string,
    buttonText: PropTypes.string
};

module.exports.constructor = CardModifyLimitView;
module.exports.CardModifyLimitView = withRouter(connect(
    (state, ownProps) => ({
        immCards: state.cards,
        immCardModifyLimit: state.cardModifyLimit,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immProfile: state.profile,
        immRevolvingPersistentData: state.revolvingPersistentData,
        redirect: ownProps.location.search.replace(/\?redirect=(.+)$/, "$1") || `/myprofile/cards/${ownProps.match.params.cardId}/details`,
        buttonText: ownProps.location.search.replace(/\?redirect=(.+)$/, "$1") && formatText("card-returnToDeferralPayments")
    }), {
    setUpStep: cardModifyLimitActions.setUpStep,
    requestLimits: cardModifyLimitActions.requestLimits,
    validateStep: cardModifyLimitActions.validateStep,
    setVisibleStep: cardModifyLimitActions.setVisibleStep,
    setWillCancel: cardModifyLimitActions.setWillCancel,
    modifyLimit: cardModifyLimitActions.modifyLimit,
    clearRequest: cardModifyLimitActions.clearRequest,
    handleAgreementCheckboxChange: cardModifyLimitActions.setAgreementCheckbox,
    handleLimitChange: cardModifyLimitActions.setLimit,
    handleCloseModal: cardModifyLimitActions.handleCloseModal,
    handleModalContinueButtonClick: cardModifyLimitActions.handleModalContinueButtonClick,
})(CardModifyLimitView));
